import { Action } from '@ngrx/store';
import {Benutzer} from '../../clients/benutzerverwaltung';

export const PAGE_STATE_RESET = '[EinstellungenPage] Page State reset';

export const BENUTZER_LISTE_LADEN = '[EinstellungenPage] Benutzerliste laden';
export const BENUTZER_SELEKTIERT = '[EinstellungenPage] Benutzer selektiert';

export const SETZE_TROUBLE_TICKET_SICHTBAR = '[EinstellungenPage] Setze Trouble Ticket sichtbar';
export const SETZE_INCIDENT_MANAGEMENT_SICHTBAR = '[EinstellungenPage] Setze Incident Management sichtbar';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

export class BenutzerListeLadenAction implements Action {
    readonly type = BENUTZER_LISTE_LADEN;
}

export class BenutzerSelektiertAction implements Action {
    readonly type = BENUTZER_SELEKTIERT;

    constructor(public payload: Benutzer) {
    }
}

export class SetzeTroubleTicketSichtbarAction implements Action {
    readonly type = SETZE_TROUBLE_TICKET_SICHTBAR;

    constructor(public payload: boolean) {}
}

export class SetzeIncidentManagementSichtbar implements Action {
    readonly type = SETZE_INCIDENT_MANAGEMENT_SICHTBAR;

    constructor(public payload: boolean) {}
}

export type Actions =
    PageStateResetAction
    | BenutzerListeLadenAction
    | BenutzerSelektiertAction
    | SetzeTroubleTicketSichtbarAction
    | SetzeIncidentManagementSichtbar
    ;
